import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { SavedIlsService } from '../services/savedIls.service'
import { TokenService } from '@monorepo/auth'

/**
 * Authentication HTTP interceptor:
 *
 * 1. Set authorization HTTP headers, no refresh token involved.
 */
@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  private tokenService = inject(TokenService);
  private router = inject(Router);
  private savedIlsService = inject(SavedIlsService);


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.tokenService.getAccessToken() ?? ''
    return next.handle(this.addToken(req, accessToken)).pipe(
      catchError((error: any) => {
        if (error.status === 401) {
          this.logoutUser()
        }
        return throwError(error)
      }),
    )
  }

  logoutUser(error: any = null) {
    const user = this.tokenService.getUser()
    if (user) {
      const ilsId = (user as any)?.ilsId
      this.savedIlsService.saveUrl(ilsId)
      this.tokenService.signOut()
      this.router.navigateByUrl(`/login/${ilsId}`)
    }
    return throwError(error)
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } }) as HttpRequest<any>
  }
}
